/*
 */
import {getCookie} from '../../common/Utils';
import {checkCookieArray} from '../../interface/ICommonbanner';

export const checkCookie = () => {
    let isCookieApply: boolean = false;
    let cookieTypeArr: checkCookieArray = {typeArr: []};
    let checkFunctional: number; 
    let lastResult: boolean;
    const htmlEl = document.getElementsByTagName("html")[0];   
    const lang = htmlEl.getAttribute('lang')? htmlEl.getAttribute('lang')!.toLocaleLowerCase() : 'ko';

    if (lang ==='ko' || (window.userData.site !== 'linw' && window.userData.site !== 'l2mru' && window.userData.site !== 'l2mnu')){
        isCookieApply = true;
    }else{        
        cookieTypeArr = JSON.parse(decodeURIComponent(getCookie('applyCookie').toString()));
        checkFunctional = cookieTypeArr?.typeArr?.indexOf('FUNCTIONAL');   
        lastResult = (checkFunctional !== undefined) && (checkFunctional > -1);       
        isCookieApply = lastResult;
    }
    //console.log('=>COOKIE? isCookieApply : ', isCookieApply );

    return isCookieApply;

};

